import styled from "styled-components";

export const TextBoxWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;

   @media (min-width: 428px) {
    width: 398px;
  } 

  
  @media (min-width: 744px) {
    width: 550px;
  } 

  @media (min-width: 1440px) {
    width: 550px;
  }
`;

export const TextBoxLabel = styled.label`
  font-weight: 300;
  font-size: 24px;
  color: #003b6f;
`;

export const TextBoxInput = styled.textarea`
  border: 1px solid #d2d9e1;
  border-radius: 12px;
  width: cal(100%-60px);
  height: 140px;
  font-weight: 300;
  font-size: 18px;
  line-height: 26px;
  resize: none;
  padding: 30px;

  @media (min-width: 428px) {
    width: 338px;
  }
  
  @media (min-width: 744px) {
    width: 490px;
  }

  @media (min-width: 1440px) {
    width: 490px;
  }
  :focus {
    outline: none !important;
    border: 1px solid #079ff4;
  }
`;
